module.exports = __webpack_public_path__ + "static/media/appLogoBig.d41fecde.png";